module.exports = __webpack_public_path__ + "img/team-member-02.c8902bc3.jpg";